import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { Separator } from "@/components/ui/separator";

export const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-charcoal-deep border-t border-border">
            {/* Main Footer */}
            <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 lg:py-20">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
                    {/* Brand */}
                    <div className="lg:col-span-1">
                        <div className="mb-6">
                            <img
                                src="/images/logo.png"
                                alt="Steuerberatung Ruberto"
                                className="h-12 w-auto"
                            />
                        </div>
                        <p className="font-sans text-sm text-muted-foreground leading-relaxed">
                            Kompetente Steuerberatung für Unternehmer und 
                            Privatpersonen seit 2006.
                        </p>
                    </div>

                    {/* Navigation */}
                    <div>
                        <h4 className="font-sans text-xs tracking-premium uppercase text-foreground mb-6">
                            Navigation
                        </h4>
                        <nav className="space-y-3">
                            <Link
                                to="/"
                                className="block font-sans text-sm text-muted-foreground hover:text-foreground transition-colors duration-300"
                            >
                                Home
                            </Link>
                            <Link
                                to="/ueber-uns"
                                className="block font-sans text-sm text-muted-foreground hover:text-foreground transition-colors duration-300"
                            >
                                Über uns
                            </Link>
                            <Link
                                to="/leistungen"
                                className="block font-sans text-sm text-muted-foreground hover:text-foreground transition-colors duration-300"
                            >
                                Leistungen
                            </Link>
                            <Link
                                to="/kontakt"
                                className="block font-sans text-sm text-muted-foreground hover:text-foreground transition-colors duration-300"
                            >
                                Kontakt
                            </Link>
                        </nav>
                    </div>

                    {/* Contact */}
                    <div>
                        <h4 className="font-sans text-xs tracking-premium uppercase text-foreground mb-6">
                            Kontakt
                        </h4>
                        <div className="space-y-4">
                            <div className="flex items-start gap-3">
                                <MapPin className="h-4 w-4 text-gold mt-0.5 flex-shrink-0" />
                                <span className="font-sans text-sm text-muted-foreground">
                                    Neuhauser Str. 27<br />
                                    80331 München
                                </span>
                            </div>
                            <div className="flex items-center gap-3">
                                <Phone className="h-4 w-4 text-gold flex-shrink-0" />
                                <span className="font-sans text-sm text-muted-foreground">
                                    +49 89 401 929 200
                                </span>
                            </div>
                            <div className="flex items-center gap-3">
                                <Mail className="h-4 w-4 text-gold flex-shrink-0" />
                                <a
                                    href="mailto:info@steuerkanzlei-ruberto.de"
                                    className="font-sans text-sm text-muted-foreground hover:text-foreground transition-colors duration-300"
                                >
                                    info@steuerkanzlei-ruberto.de
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Legal */}
                    <div>
                        <h4 className="font-sans text-xs tracking-premium uppercase text-foreground mb-6">
                            Rechtliches
                        </h4>
                        <nav className="space-y-3">
                            <Link
                                to="/impressum"
                                className="block font-sans text-sm text-muted-foreground hover:text-foreground transition-colors duration-300"
                            >
                                Impressum
                            </Link>
                            <Link
                                to="/datenschutz"
                                className="block font-sans text-sm text-muted-foreground hover:text-foreground transition-colors duration-300"
                            >
                                Datenschutz
                            </Link>
                        </nav>
                    </div>
                </div>
            </div>

            {/* Bottom Bar */}
            <div className="border-t border-border">
                <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6">
                    <div className="flex flex-col md:flex-row items-center justify-between gap-4">
                        <p className="font-sans text-xs text-muted-foreground">
                            © {currentYear} Steuerberatung Ruberto. Alle Rechte vorbehalten.
                        </p>
                        <Separator className="hidden md:block w-px h-4 bg-border" orientation="vertical" />
                        <p className="font-sans text-xs text-muted-foreground">
                            München · Deutschland
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
